// ─── Workshop Truck Availability Tracker ───
// StatusBadge – Coloured pill showing a truck's workshop status
// IASL Technical Academy / Lafarge Driving Institute, Nigeria

import type { WorkshopStatus } from '@/types'
import { STATUS_BG_COLORS } from '@/utils/helpers'

interface StatusBadgeProps {
  status: WorkshopStatus
  size?: 'sm' | 'md'
}

export default function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const colorClasses = STATUS_BG_COLORS[status] ?? 'bg-gray-100 text-gray-700'

  const sizeClasses = size === 'sm'
    ? 'text-xs px-2 py-0.5'
    : 'text-sm px-3 py-1'

  return (
    <span
      className={`inline-block rounded-full font-medium ${colorClasses} ${sizeClasses}`}
    >
      {status}
    </span>
  )
}
